
const TermsSection = () => {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-8">
            ⚖️ Legal Framework
          </h2>
          <p className="text-lg text-muted-foreground max-w-4xl mx-auto mb-8">
            Please read our legal framework carefully. The Bromentum network is decentralized, non-incorporated, and fully community-run.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-6">
          <div className="bg-red-500/10 border border-red-500/20 rounded-lg p-6">
            <h3 className="text-xl font-bold text-foreground mb-4">🚨 Primary Legal Statement</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              $TOP1 is a community-launched, non-custodial, meme-focused token with no intrinsic value. It is not a security, stock, bond, or financial instrument. Use of this site and token is at your own discretion. The Bromentum network is decentralized, non-incorporated, and fully community-run.
            </p>
          </div>
          
          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-6">
            <h3 className="text-xl font-bold text-foreground mb-4">🤝 Community Governance</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              All funds collected are allocated for public tools and meme ops via transparent multisig systems. There is no central team, no entity, and no equity. Resources collected via the Community Mint are used to fund bot development, meme campaigns, and on-chain coordination tools.
            </p>
          </div>
          
          <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-6">
            <h3 className="text-xl font-bold text-foreground mb-4">🔗 Partnership Disclaimer</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Any partnerships or integrations are collaborative in nature. $TOP1 holders do not receive equity, revenue shares, or ownership rights of any third-party platform. Participation in Bromentum does not constitute a financial arrangement.
            </p>
          </div>
          
          <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-6">
            <h3 className="text-xl font-bold text-foreground mb-4">🎯 Purpose Statement</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              All tokens are for utility, experimentation, and culture. We don't just build in Web3 — we build with the Web3 community. Whether you're a gamer, meme warrior, creator, or founder, there's a place for you in Bromentum.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsSection;
